import React, { useState,useEffect,useContext } from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import { ContextData } from '../../../../../../context/Context';
import axios from 'axios';
import baseUrl from "../../../../../../BaseURL";
import Sponsor from "../../Forms/loan/Sponsor";
import SpouseDetails from "../../Forms/loan/SpouseDetails";
import ResdentialAddress from "../../Forms/loan/ResdentialAddress";
import EmploymentDetails from "../../Forms/loan/EmploymentDetails";
import SalaryBankDetails from "../../Forms/loan/SalaryBankDetails";
import PersonalReference from "../../Forms/loan/PersonalReference";
import GuarantorDetails from "../../Forms/loan/GuarantorDetails";
import LoanRequestInfo from "../../Forms/loan/LoanRequestInfo";
import { Getrequest } from "../../../../../../context/AxiosRequest";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import DownloadINDEMNITYFORM from "../../Forms/loan/DownloadINDEMNITYFORM";
import SoundAlert from "../../../../../../routes/SoundAlert";
import GetPersonData from "../../../../../../context/GetPersonData";



export default function LoanApplication() {


  const [activeStep, setActiveStep] = React.useState(0);
  
  const [Data,setData] = useState(null)
  const {UserTokens,accesstoken,ReloadBioForms,setBioProgressStatus,ChangeLoanForm,setChangeLoanForm} = useContext(ContextData)
  const [steps,setsteps] = useState([])
  const [SectionListName,setSectionListName] = useState("loanrequestComplete")
  const [Check_verify_status,setCheck_verify_status] = useState([])
  const Navigate = useNavigate()


  useEffect(()=>{
 

     if(ChangeLoanForm === "thirdparty"){
       setsteps(["Loan Request Form","Sponsor Identification", "Spouse Details", "Resdential Address", "Employment Details", "Salary Bank Details","Personal Reference","Guarantor Details","File Downloads" ]) ;
     }else if(ChangeLoanForm === "studentloan"){

       setsteps( ["Loan Request Form","Guarantor Details","Spouse Details","Resdential Address","Employment Details","Salary Bank Details","Personal Reference","File Downloads"]) ;
     }
        





  },[ChangeLoanForm])



  const [formData, setFormData] = useState({

    loanrequest: {

    loanAmount: "",
    tenor : "",
    netMonthlyIncome : "",
    loanCategory : "",
    program_type: "",

     },

     sponsorIdentification:{
            
        first_name: "",
        middle_name:  "",
        surname: "",
        date_of_birth:  "",
        gender: "",
        marital_status:  "",
        phone_no_1:  "",
        phone_no_2:  "",
        email:  "",
        number_of_dependants:  "",
        mother_maiden_name:  "",
        bvn:  "",
        nin_number:  "",
        tin_number: "",
        billing_address:  ""
           
     }
     ,

     spouse_details:{

    first_name:  "",
    middle_name:  "",
    surname:  "",
    office_address: "",
    phone_no_1:  "",
    phone_no_2: "",
    email:  "",

     }
     ,

     residentialAddress:{

       residential_address: "",
       residential_status : "",
       years_in_apartment: "",
       nearest_landmark: "",
       profession: "",
       profession_type: "",
       position: "",

     },

     salary_bank_details:{

       signature_date: "",
       account_name: "",
       bank: "",
       account_number: "",
       account_type: "",

     },
      personal_references:{

      first_ref_first_name: "",
      first_ref_middle_name: "",
      first_ref_surname: "",
      first_ref_relationship: "",
      first_ref_address: "",
      first_ref_phone_no_1: "",
      first_ref_phone_no_2: "",
      first_ref_email: "",
      second_ref_first_name: "",
      second_ref_middle_name: "",
      second_ref_surname: "",
      second_ref_relationship: "",
      second_ref_address: "",
      second_ref_phone_no_1: "",
      second_ref_phone_no_2: "",
      second_ref_email: "",

      },

      guarantor_details:{

          first_name:  "",
          middle_name:   "",
          surname:  "",
          date_of_birth:   "",
          gender:   "",
          phone_no_1:   "",
          phone_no_2:   "",
          marital_status:   "",
          email:  "",
          psn_no:   "",
          mother_maiden_name:   "",
          account_name:   "",
          account_number:   "",
          bvn:  "",
          nin_number:   "",
          bank_name:   "",
          tin_number:   "",
          home_address:   "",
          office_address:   "",
      }

    


   
   
  });





  useEffect(()=>{
      

    async function FetchData(){
            //  setLoader(true)  

          try {
            const response = await Getrequest(`${baseUrl}/auth/get_loan_data/${UserTokens}`,accesstoken) 

              
            
         //   setData(response.data[0])
        
         setFormData((prev) => ({
          ...prev,
          loanrequest: { 
            
             loanAmount: response.loanrequest[0]?.loan_amount,
             tenor: response.loanrequest[0]?.tenor,
             netMonthlyIncome: response.loanrequest[0]?.net_monthly_income,
             loanCategory: response.loanrequest[0]?.loan_category,
             program_type: response.loanrequest[0]?.program_type
             
               }, 
          


          sponsorIdentification:{

                  first_name: response.sponsorIdentification[0]?.first_name ,
                  middle_name: response.sponsorIdentification[0]?.middle_name ,
                  surname: response.sponsorIdentification[0]?.surname ,
                  date_of_birth: response.sponsorIdentification[0]?.date_of_birth ,
                  gender: response.sponsorIdentification[0]?.gender ,
                  marital_status: response.sponsorIdentification[0]?.marital_status ,
                  phone_no_1: response.sponsorIdentification[0]?.phone_no_1 ,
                  phone_no_2: response.sponsorIdentification[0]?.phone_no_2 ,
                  email: response.sponsorIdentification[0]?.email ,
                  number_of_dependants: response.sponsorIdentification[0]?.number_of_dependants ,
                  mother_maiden_name: response.sponsorIdentification[0]?.mother_maiden_name ,
                  bvn: response.sponsorIdentification[0]?.bvn ,
                  nin_number: response.sponsorIdentification[0]?.nin_number ,
                  tin_number: response.sponsorIdentification[0]?.tin_number ,
                  billing_address: response.sponsorIdentification[0]?.billing_address 
          },

          spouse_details:{

              first_name: response.spouse_details[0]?.first_name,
              middle_name: response.spouse_details[0]?.middle_name,
              surname: response.spouse_details[0]?.surname,
              office_address: response.spouse_details[0]?.office_address,
              phone_no_1: response.spouse_details[0]?.phone_no_1,
              phone_no_2: response.spouse_details[0]?.phone_no_2,
              email: response.spouse_details[0]?.email,

          },

            residentialAddress:{

            residential_address: response.residentialAddress[0]?.residential_address,
            residential_status : response.residentialAddress[0]?.residential_status,
            years_in_apartment: response.residentialAddress[0]?.years_in_apartment,
            nearest_landmark: response.residentialAddress[0]?.nearest_landmark,
            profession: response.residentialAddress[0]?.profession,
            profession_type: response.residentialAddress[0]?.profession_type,
            position: response.residentialAddress[0]?.position,

            },
            
           employment_details: {
              employer_name : response.employment_details[0]?.employer_name,
              employer_address : response.employment_details[0]?.employer_address,
              year_of_confirmation  : response.employment_details[0]?.year_of_confirmation,
              gross_annual_income  : response.employment_details[0]?.gross_annual_income,
              psn_ippis : response.employment_details[0]?.psn_ippis,
              year_of_retirement : response.employment_details[0]?.year_of_retirement,
              net_monthly_income  : response.employment_details[0]?.net_monthly_income,
              grade_level   : response.employment_details[0]?.grade_level,
              salary_payment_date  : response.employment_details[0]?.salary_payment_date,
              employee_id  : response.employment_details[0]?.employee_id,
              qualification  : response.employment_details[0]?.qualification,
            },

      salary_bank_details:{

                account_name: response.salary_bank_details[0]?.account_name,
                bank: response.salary_bank_details[0]?.bank,
                account_number: response.salary_bank_details[0]?.account_number,
                account_type: response.salary_bank_details[0]?.account_type,
                signature_date: response.salary_bank_details[0]?.signature_date,

            },
             personal_references:{

                first_ref_first_name: response.personal_references[0].first_ref_first_name,
                first_ref_middle_name: response.personal_references[0].first_ref_middle_name,
                first_ref_surname: response.personal_references[0].first_ref_surname,
                first_ref_relationship: response.personal_references[0].first_ref_relationship,
                first_ref_address: response.personal_references[0].first_ref_address,
                first_ref_phone_no_1: response.personal_references[0].first_ref_phone_no_1,
                first_ref_phone_no_2: response.personal_references[0].first_ref_phone_no_2,
                first_ref_email: response.personal_references[0].first_ref_email,
                second_ref_first_name: response.personal_references[0].second_ref_first_name,
                second_ref_middle_name: response.personal_references[0].second_ref_middle_name,
                second_ref_surname: response.personal_references[0].second_ref_surname,
                second_ref_relationship: response.personal_references[0].second_ref_relationship,
                second_ref_address: response.personal_references[0].second_ref_address,
                second_ref_phone_no_1: response.personal_references[0].second_ref_phone_no_1,
                second_ref_phone_no_2: response.personal_references[0].second_ref_phone_no_2,
                second_ref_email: response.personal_references[0].second_ref_email,
      
      }

   
      ,

       guarantor_details:{

          first_name: response.guarantor_details[0].first_name,
          middle_name: response.guarantor_details[0].middle_name,
          surname: response.guarantor_details[0].surname,
          date_of_birth: response.guarantor_details[0].date_of_birth,
          gender: response.guarantor_details[0].gender,
          phone_no_1: response.guarantor_details[0].phone_no_1,
          phone_no_2: response.guarantor_details[0].phone_no_2,
          marital_status: response.guarantor_details[0].marital_status,
          email: response.guarantor_details[0].email,
          psn_no: response.guarantor_details[0].psn_no,
          mother_maiden_name: response.guarantor_details[0].mother_maiden_name,
          account_name: response.guarantor_details[0].account_name,
          account_number: response.guarantor_details[0].account_number,
          bvn: response.guarantor_details[0].bvn,
          nin_number: response.guarantor_details[0].nin_number,
          bank_name: response.guarantor_details[0].bank_name,
          tin_number: response.guarantor_details[0].tin_number,
          home_address: response.guarantor_details[0].home_address,
          office_address: response.guarantor_details[0].office_address
      }


        }));
           
     setChangeLoanForm(response.loanrequest[0]?.loan_category)


          } catch (err) {
             if(err) console.log(err.message)
            // setLoader(false)
          }

         
    }FetchData()



              GetPersonData(UserTokens,accesstoken).then(res=>{
                
              const verify_status = res.sign_up[0]?.verify_status
              setCheck_verify_status(verify_status)
                 
                   
         })

},[ReloadBioForms])



  // Handle Input Change
  const handleChange = (e, section) => {
    

    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [section]: {
        ...prevData[section],
        [name]: value,
      },
    }));
    



  };

   


  const handleSubmit = () => {


          Navigate("/application/upload_document")

  };



  const handleNext = async() => {

      
        const response = await Getrequest(`/auth/Check_if_all_inputs_are_set/${UserTokens}/${SectionListName}`,accesstoken)
      
            if(!response.status){
         
                toast.warn(response.textStatus)
                SoundAlert("error")
               //  setActiveStep((prev) => prev + 1);
                return 

              }else{

                 toast.success(response.textStatus)
                 SoundAlert("notification")
                 setActiveStep((prev) => prev + 1);
              } 


  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  useEffect(()=>{
           

  

          if(ChangeLoanForm === "thirdparty"){

            switch (activeStep) {
      
                    case 0:
    
                    return    setSectionListName("loanrequestComplete")
    
                    case 1: 
    
                    return  setSectionListName("sponsorIdentificationComplete")
    
                    case 2:
    
                    return  setSectionListName("spouse_detailsComplete")
    
                    case 3:
    
                    return   setSectionListName("residentialAddressComplete")
    
                    case 4:
    
                    return (
                    setSectionListName("employment_detailsComplete")
                    );
    
                    case 5:
    
                    return (
                    setSectionListName("salary_bank_detailsComplete")
                    );
    
    
                    case 6:
    
                    return (
                    setSectionListName("personal_referencesComplete")
                    );
    
                    case 7:
    
                    return (
                    setSectionListName("guarantor_detailsComplete")
                    );
    
    
                    
                    }
 
          } else if(ChangeLoanForm === "studentloan"){

                   switch (activeStep) {
      
                    case 0:
    
                    return    setSectionListName("loanrequestComplete")
    
                    case 1: 
    
                    return  setSectionListName("guarantor_detailsComplete")
    
                    case 2:
    
                    return  setSectionListName("spouse_detailsComplete")
    
                    case 3:
    
                    return   setSectionListName("residentialAddressComplete")
    
                    case 4:
    
                    return (
                    setSectionListName("employment_detailsComplete")
                    );
    
                    case 5:
    
                    return (
                    setSectionListName("salary_bank_detailsComplete")
                    );
    
    
                    case 6:
    
                    return (
                    setSectionListName("personal_referencesComplete")
                    );
                   

                    }
                  }


      



     
  },[activeStep])

  const renderFormSection = () => {
     
    if(ChangeLoanForm === "thirdparty"){

      if (steps[activeStep]) {

        switch (activeStep) {
  
            case 0:

            return <LoanRequestInfo formData={formData} handleChange={handleChange}  />;
  
             case 1: 

             return <Sponsor formData={formData} handleChange={handleChange}  />;
  
             case 2:

              return  <SpouseDetails formData={formData} handleChange={handleChange} />
  
               case 3:

                return  <ResdentialAddress formData={formData} handleChange={handleChange} /> 
               
                 case 4:

                  return (
                     <EmploymentDetails formData={formData} handleChange={handleChange} />
                  );
  
                    case 5:

               return (
                       <SalaryBankDetails  formData={formData} handleChange={handleChange} />
                );
  
  
            case 6:

            return (
               <PersonalReference  formData={formData} handleChange={handleChange} />
            );

            case 7:

            return (
               <GuarantorDetails  formData={formData} handleChange={handleChange} />
            );
            case 8:
            return (
                 <DownloadINDEMNITYFORM  formData={formData} handleChange={handleChange} />
            );
           
   
          default:
            return null;
        }
      }

    }else if(ChangeLoanForm === "studentloan"){

          if (steps[activeStep]) {
        switch (activeStep) {
  
            case 0:
            return <LoanRequestInfo formData={formData} handleChange={handleChange}  />;
  
             case 1: 
            return  <GuarantorDetails  formData={formData} handleChange={handleChange} />
  
            case 2:
              return   <SpouseDetails formData={formData} handleChange={handleChange} />

              case 3:
                return  <ResdentialAddress formData={formData} handleChange={handleChange} />  
 
               
                case 4:

                  return (
                      <EmploymentDetails formData={formData} handleChange={handleChange} /> 
                  );
  
                    case 5:

            return (
                <SalaryBankDetails  formData={formData} handleChange={handleChange} />
            );
  
  
            case 6:

            return (
                 <PersonalReference  formData={formData} handleChange={handleChange} />
            );
            
            case 7:

            return (
                 <DownloadINDEMNITYFORM  formData={formData} handleChange={handleChange} />
            );
           
  
  
          default:
            return null;

        }
      }
    }
    return null;
  }; 

  let checkStatus = ["verified","approved","returned_by_approver","accepted","rejected"]
  if(checkStatus.includes(Check_verify_status.length > 0 && Check_verify_status)){

        Navigate("/application/home")
        toast.warn("Your application cannot be modified after verification")
        toast.success("Application locked. Visit my application page to review the submission status")
         SoundAlert("error")
         return
  
  } 
    
  
  return (
   

    <div
      style={{ margin: "2rem auto", maxWidth: "900px", padding: "0 1.5rem" }}
      className="font-mono"
      >
      {
        ChangeLoanForm === "studentloan" && 
       
        <h1 className="mb-4 text-center"> {steps[activeStep] !== "Guarantor Details" && <span>Guarantor's</span>}  {steps[activeStep]}</h1>
      }

                           {
        ChangeLoanForm === "thirdparty" ? (
    <div className="text-center p-4">
      <h2 className="text-lg font-semibold text-green-800 mb-2">
        Sponsor Information and Related Details
      </h2>
      <p className="text-gray-700 text-sm leading-relaxed">
        This section captures information about the individual (s) sponsoring your education.
        Please ensure that all sponsor details provided are accurate and verifiable, as they will be used
        during the loan verification and approval processes. Any incomplete or incorrect information may delay or lead to the disqualification of your application.
        A sponsor shall be a civil Servant in the Federal, State, Local Government or Organized Private Sector.
      </p>
    </div>
  ) : (
    <div className="text-center p-4">
      <h2 className="text-lg font-semibold text-green-800 mb-2">
        Guarantors’ Information and Related Details
      </h2>
      <p className="text-gray-700 text-sm leading-relaxed whitespace-pre-line text-justify">
        Eligibility for Guarantorship: A Guarantor shall be: A civil servant in the Federal, State, or Local Government not below the rank of an equivalent of an Assistant Director, or not below Grade Level 15; A Chief Magistrate or a Judge or Justice of a superior court of record; An academic staff of a tertiary institution not below the rank of an equivalent of Lecturer II, or a non-academic staff not below the rank of Assistant Registrar; A traditional ruler not below the position of a District Head; A military, police or paramilitary officer not below the rank or an equivalent of lieutenant; and Any person in the Private Sector who the Partner Bank is satisfied with their income and earnings.
      </p>
      {SectionListName} {activeStep}
    </div>
  )
}
      
      <Stepper id="form-stepper" activeStep={activeStep} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
            <p className="text-center pt-2 text-red-700">Enter N/A if the information is not available or not applicable</p>
      <div className="font-mono" style={{ margin: "2rem 0" }}>{renderFormSection()}</div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          onClick={handleBack}
          disabled={activeStep === 0}
          variant="outlined"
          sx={{marginBottom:"20px"}} 
        >
          Back
        </Button>

        {activeStep < steps.length - 1 ? (
          <Button sx={{marginBottom:"20px"}} onClick={handleNext} variant="contained" color="primary">
            Next
          </Button>
        ) : (
          <Button sx={{marginBottom:"20px"}}   onClick={handleSubmit} variant="contained" color="primary">
            Go to next step
          </Button>
        )}
      </div>
         <div className="mt-10 text-center mb-9 text-slate-400 text-xs md:text-sm">
        Powered by <span className="font-semibold text-slate-600">MastermindTech</span>
      </div>
    </div>
  );
}

